var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h24v24H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "scale(.02083)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "b",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABC0lEQVRoge2ZQQrCQAxFU/EoHktPIaIrV1b0BK7qUbyAK1eueg9daQZmoAwV2jSTaWwefAqFJnkwpdMWwDBEOGLemI9QXK+SU0By+JAXp4D08CFJBFJjAmJFJXuZQO5eJtCD2vepOYtKCiwwa39kQ1IgCSbQoMAsfQqGep3gEphhqkat1cB6neEQiIdXJdA2fOXPizBEwK3zS1TjCoLDA9AFRjE8AE1gjnlG194xO8yWmA0QH3AUgVt0HVdIW4xJCrQtoQfmjDkRswfBJeRQfRMHRiEx6QdZQPVWIqB6MxdQvZ3Ohgn0QP1LvfrPKkl6mUDuXiaQu9dfCUiGDfW/WUthCdfrwClgGD/4AggZtsTqc2fuAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/LOGIN.322147e3da1df6ebbe2808904e9329d6.svg";
export { ForwardRef as ReactComponent };